import React from 'react';

interface IntersectionObserverCallback {
  (entry: IntersectionObserverEntry): void;
}

export const useIntersectionObserver = (
  callback: IntersectionObserverCallback,
  options: IntersectionObserverInit = { threshold: 1.0 }
) => {
  const [target, setTarget] = React.useState<HTMLElement>();

  React.useEffect(() => {
    if (callback && target) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            callback(entry);
          }
        });
      }, options);

      observer.observe(target);

      return () => observer.disconnect();
    }

    return undefined;
  }, [callback, target, options]);

  return React.useCallback((node) => {
    if (node !== null) {
      setTarget(node);
    }
  }, []);
};
